<template>
  <div class="-my-3 flex flex-col divide-y">
    <div
      v-for="groupedPermission in Object.entries(groupedPermissions)"
      :key="groupedPermission[0]"
      class="flex flex-col gap-2 py-3"
    >
      <h3 class="text-base font-semibold capitalize-first">
        {{
          $t(
            `enums.config.permissions.permissions_group.${groupedPermission[0].toLowerCase()}`
          )
        }}
      </h3>
      <div class="grid grid-cols-3 gap-3">
        <PermissionButton
          v-for="permission in groupedPermission[1]"
          :key="permission"
          :guard-type="'permission'"
          :guard-name="permission"
          :disabled="roleHasPermission(permission) || !editionMode"
          :selected="isSelected(permission)"
          :label="$t(`enums.config.permissions.permissions.${permission}`)"
          @click="addOrRemove(permission)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PermissionButton from '@c/RolesAndPermissions/component/PermissionButton.vue'

export default {
  name: 'UserPermissionTable',
  components: { PermissionButton },
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    groupedPermissions: {
      type: Object,
      required: true
    },
    permissionsFromRoles: {
      type: Array,
      required: true
    },
    editionMode: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue'],
  computed: {
    localPermissions: {
      get() {
        return this.modelValue || []
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    addOrRemove(permission) {
      if (this.editionMode) {
        if (this.isSelected(permission)) {
          if (this.roleHasPermission(permission)) {
            this.$h.toastInfo(
              this.$t('toasts.this_permission_is_linked_to_role')
            )
          } else {
            this.localPermissions.splice(
              this.localPermissions.indexOf(permission),
              1
            )
          }
        } else {
          this.localPermissions.push(permission)
        }
      }
    },
    isSelected(permission) {
      return (
        this.localPermissions.includes(permission) ||
        this.roleHasPermission(permission)
      )
    },
    roleHasPermission(permission) {
      return (this.permissionsFromRoles || []).includes(permission)
    }
  }
}
</script>
